import { combineReducers } from 'redux'
import installments from './installments'
import acceptTerm from './acceptTerm'

export default combineReducers({
  installments,
  acceptTerm
})
